import { Check } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { BottomAppBar } from '../../../../components/BottomAppBar';
import { PageHeader } from '../../../../components/PageHeader';
import { useSafeNavigation } from '../../../../hooks/useSafeNavigation';
import { PageContent, PageLayout } from '../../../../layout';
import { useConfirmInvoiceForm } from '../../../../modules/invoice/hooks/useConfirmInvoiceForm';
import { InvoiceFormModule } from '../../../../modules/invoice/InvoiceFormModule';
import { notify } from '../../../../utils/notification';

export const NewInvoicePage = () => {
  const { invoiceId } = useParams();
  const { t } = useTranslation('page-new-invoice');
  const { safeNavigate } = useSafeNavigation();

  const {
    onFormSubmit,
    state: { isReady, isLoading },
  } = useConfirmInvoiceForm({
    onSuccess: (id) => safeNavigate(`/new/invoice/${id}/start-reminding`),
    onError: () => {
      notify.negative({
        title: t('error.mutation.title'),
        message: t('error.mutation.text'),
      });
    },
    onValidationError: () => {
      notify.negative({
        title: t('error.validation.title'),
        message: t('error.validation.text'),
      });
    },
  });

  return (
    <PageLayout>
      <PageHeader title={t('title')} subtitle={t('subtitle')} />
      <PageContent>
        {invoiceId ? (
          <InvoiceFormModule
            invoiceId={invoiceId}
            invoiceFormProps={{
              onSubmit: (data) => onFormSubmit(invoiceId, data),
              defaultValidated: false,
              allowInvoiceItems: true,
            }}
          />
        ) : null}
      </PageContent>
      <BottomAppBar stackProps={{ justifyContent: 'flex-end' }}>
        <LoadingButton
          loading={isLoading}
          disabled={!isReady}
          type={'submit'}
          form={'invoice-form'}
          variant={'contained'}
          size={'large'}
          startIcon={<Check />}
        >
          {t('action.confirm')}
        </LoadingButton>
      </BottomAppBar>
    </PageLayout>
  );
};
